import React, { useState } from 'react';
import '../styles/Boutique.css';
import '../styles/AppAgt.css';
import '../styles/PresentationHomogene.css';
import Footer from '../components/Footer';

// Import des composants de contenu
import NouveautesContent from './Boutique/NouveautesContent';
import CartesContent from './Boutique/CartesContent';
import LivresContent from './Boutique/LivresContent';
import MugsContent from './Boutique/MugsContent';
import SetsContent from './Boutique/SetsContent';
import TeeshirtsContent from './Boutique/TeeshirtsContent';
import MagnetsContent from './Boutique/MagnetsContent';
import DiversContent from './Boutique/DiversContent';

const Boutique = () => {
    const [activeCategory, setActiveCategory] = useState(null);

    const toggleCategory = (categoryId) => {
        setActiveCategory(activeCategory === categoryId ? null : categoryId);
    };

    const categories = [
        { 
            id: 'nouveautes', 
            name: 'Nouveautés 2026', 
            icon: '✨', 
            color: '#e74c3c', 
            special: true,
            content: <NouveautesContent />
        },
        { 
            id: 'cartes', 
            name: 'Cartes postales', 
            icon: '📮', 
            color: '#3498db',
            content: <CartesContent />
        },
        { 
            id: 'livres', 
            name: 'Livres', 
            icon: '📚', 
            color: '#2ecc71',
            content: <LivresContent />
        },
        { 
            id: 'mugs', 
            name: 'Mugs', 
            icon: '☕', 
            color: '#f39c12',
            content: <MugsContent />
        },
        { 
            id: 'sets', 
            name: 'Sets de table', 
            icon: '🍽️', 
            color: '#9b59b6',
            content: <SetsContent />
        },
        { 
            id: 'teeshirts', 
            name: 'Tee shirts', 
            icon: '👕', 
            color: '#1abc9c',
            content: <TeeshirtsContent />
        },
        { 
            id: 'magnets', 
            name: 'Magnets', 
            icon: '🧲', 
            color: '#e67e22',
            content: <MagnetsContent />
        },
        { 
            id: 'Miel', 
            name: 'Miel', 
            icon: '🎁', 
            color: '#34495e',
            content: <DiversContent />
        }
    ];

    return (
        <div className='AppAgt'>
            <div className='boutique-modern'>
                {/* Hero Section */}
                <div className='boutique-hero'>
                    <div className='boutique-hero-content'>
                        <h1 className='boutique-title'>Boutique Souvenirs</h1>
                        <p className='boutique-subtitle'>Musée de la Gare de Trôo</p>
                        <div className='boutique-description'>
                            <p>Découvrez notre sélection de souvenirs et de produits locaux.</p>
                        </div>
                    </div>
                </div>

                {/* Categories with Accordion */}
                <div className='boutique-categories'>
                    <div className='categories-container'>
                        <h2 className='categories-title'>Nos Produits</h2>
                        <div className='categories-accordion'>
                            {categories.map((category, index) => (
                                <div 
                                    key={index}
                                    className={`category-accordion-item ${category.special ? 'category-special' : ''}`}
                                    style={{'--category-color': category.color}}
                                >
                                    <div 
                                        className={`category-header ${activeCategory === category.id ? 'active' : ''}`}
                                        onClick={() => toggleCategory(category.id)}
                                    >
                                        <div className='category-header-content'>
                                            <div className='category-icon'>{category.icon}</div>
                                            <h3 className='category-name'>{category.name}</h3>
                                            <div className={`category-toggle ${activeCategory === category.id ? 'active' : ''}`}>
                                                {activeCategory === category.id ? '−' : '+'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`category-content-wrapper ${activeCategory === category.id ? 'active' : ''}`}>
                                        {category.content}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Info Section */}
                <div className='boutique-info'>
                    <div className='info-cards'>
                        <div className='info-card'>
                            <div className='info-icon'>🚂</div>
                            <h3>Patrimoine Ferroviaire</h3>
                            <p>Nos produits souvenir du train touristique et nos livres sur les Autorails</p>
                        </div>
                        <div className='info-card'>
                            <div className='info-icon'>🎨</div>
                            <h3>Artisanat Local</h3>
                            <p>Nous privilégions des créateurs et des produits locaux</p>
                        </div>
                        <div className='info-card'>
                            <div className='info-icon'>💝</div>
                            <h3>Idées Cadeaux</h3>
                            <p>Des souvenirs uniques pour tous les âges et toutes les occasions</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Boutique;